import React from 'react'

export default function CategoryBox(props){
    const selectedItem = props.isSelected ? 'cta' : ''
    const classes = `categoryBox shadowOpacity ${selectedItem}`

    return (
        <div onClick={()=>{
            if(props.isSelected){
                props.callback(props.categoryDetail.title,false);
                return;
            }
            props.callback(props.categoryDetail.title,true);
        }} className="personalizationColumn">
            <div className='categoryBox' >
                <img alt="category" src={props.categoryDetail && props.categoryDetail.imgUrl &&  props.categoryDetail.imgUrl}></img>
                <div>{props.categoryDetail &&  props.categoryDetail.title && props.categoryDetail.title}</div>
            </div>
            <div className={classes}></div>
        </div>
    )
}